// CSV Templates organized by language
export const csvTemplates = {
  en: {
    blocks: '/src/templates/csv/en/blocks_template_en.csv',
    apartmentUnits: '/src/templates/csv/en/apartment_units_template_en.csv',
    residents: '/src/templates/csv/en/residents_template_en.csv',
    employees: '/src/templates/csv/en/employees_template_en.csv',
    assets: '/src/templates/csv/en/assets_template_en.csv',
    vendors: '/src/templates/csv/en/vendors_template_en.csv'
  },
  es: {
    blocks: '/src/templates/csv/es/blocks_template_es.csv',
    apartmentUnits: '/src/templates/csv/es/apartment_units_template_es.csv',
    residents: '/src/templates/csv/es/residents_template_es.csv',
    employees: '/src/templates/csv/es/employees_template_es.csv',
    assets: '/src/templates/csv/es/assets_template_es.csv',
    vendors: '/src/templates/csv/es/vendors_template_es.csv'
  },
  pt: {
    blocks: '/src/templates/csv/pt/blocks_template_pt.csv',
    apartmentUnits: '/src/templates/csv/pt/apartment_units_template_pt.csv',
    residents: '/src/templates/csv/pt/residents_template_pt.csv',
    employees: '/src/templates/csv/pt/employees_template_pt.csv',
    assets: '/src/templates/csv/pt/assets_template_pt.csv',
    vendors: '/src/templates/csv/pt/vendors_template_pt.csv'
  }
} as const;

export type SupportedLanguage = keyof typeof csvTemplates;
export type TemplateType = keyof typeof csvTemplates.en;
